import { Row } from 'react-table';
import _sumBy from 'lodash/sumBy';

import { summarizeRowsAbove } from '../constants';

type SumByFn = (row: Row<TrqkGapChannelAudio>) => number;

interface SumFooterValueInput {
    /**
     * Array of rows to sum
     */
    rows: Row<TrqkGapChannelAudio>[];
    /**
     * Function which will be used to look up the value to be added for each row
     */
    sumByFn: SumByFn;
}

/**
 * Sums up a footer value from an array of rows
 * @param input - see {@link SumFooterValueInput}
 * @returns - sum to display as the footer value
 */
export const sumFooterValue = ({
    rows,
    sumByFn,
}: SumFooterValueInput): number =>
    rows.reduce((acc: number, row: Row<TrqkGapChannelAudio>) => {
        const { canExpand, isExpanded } = row;

        // If the row should not be summarized, just count the row itself. In this case, the
        // aggregated value will be used.
        if (row.subRows.length <= summarizeRowsAbove) {
            return acc + sumByFn(row);
        }

        // When the row can be expanded, but is not expanded, we need to count all the sub-rows
        // because they are otherwise removed from the array of rows
        if (canExpand && !isExpanded) {
            return acc + _sumBy(row.subRows, sumByFn);
        }

        return acc;
    }, 0);
